import React from 'react'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { useParamsInt } from '../../../../../../shared/hooks/location'
import { Menu, MenuAdd, MenuItem, MenuRemove } from '../../../../../../shared/menu/menu'
import { useApiListGroupUser } from '../../../../../../api-new/state/content'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { IconCheck, IconUsers } from '../../../../../../shared/icon/icon'
import { useModalActionID } from '../../../../../../shared/component/modal-dialog'
import { PermissionGroupUserModal } from '../../../../../../shared/permission-modal/permission-group-user-modal'
import { useRoleOrgGroup, useRoleOrgGroupUser } from '../../../../../../role/hook/role-org'
import { TableAgClient } from '../../../../../../shared/table-builder/table-ag-client'
import { ColumnFormat, ColumnMenu, ColumnText } from '../../../../../../shared/table-builder/table-columns'
import { KEEP_MEMBERSHIP_TIP, ManagedByPartnerChip, isManagedByPartner } from '../../../../../../shared/partner/partner-words'
import { MANAGED_GROUP_LABEL, ManagedGroupChip, managedGroupTip, useManagedGroups } from '../../../../../../shared/scim/managed-groups'
import { Notice } from '../../../../../../shared/sso-workspace/fleet-page'

// A membership the partner API manages (Phase E, ruling E-11) carries the
// "Managed by partner" chip; keep adds it as the organization's own (a
// person's add takes the row over), so the partner's sync never removes it.
const managedCell = cell => (isManagedByPartner(cell.data) ? <ManagedByPartnerChip /> : '')

export const GroupListUser = () => {
  const { groupID } = useParamsInt()

  const apiListGroupUser = useApiListGroupUser()

  const [target, show, hide] = useModalActionID()

  const roleOrgGroupUser = useRoleOrgGroupUser()
  // A group the identity provider manages (SCIM Groups): nobody is added
  // here, and the members it put there are never removed here; a member who
  // got in another way (a sign-up form, an invite) can be.
  const roleOrgGroup = useRoleOrgGroup()
  const { managed } = useManagedGroups({ enabled: roleOrgGroup.accessRead })
  const managedBy = managed(groupID)
  const editable = managedBy === null
  const canAdd = roleOrgGroupUser.accessCreate && editable
  const canDelete = roleOrgGroupUser.accessDelete && editable
  const canDeleteRow = row => roleOrgGroupUser.accessDelete && (editable || !row.managedByIdentityProvider)
  const idpCell = cell => (!editable && cell.data && cell.data.managedByIdentityProvider ? <ManagedGroupChip connectionName={managedBy} /> : '')

  const handleReady = async () => await apiListGroupUser.get(`${groupID}/group`)
  const handleDestroyed = () => apiListGroupUser.init()

  const handleAddShow = () => show()
  const handleClose = () => hide()

  const handleClosed = async () => apiListGroupUser.get(`${groupID}/group`)

  const handleDelete = async item => {
    await apiListGroupUser.delete(`${item.groupID}/${item.userID}`)
    await apiListGroupUser.get(`${groupID}/group`)
  }

  const handleKeep = async item => {
    await apiListGroupUser.post({ groupID: item.groupID, userID: item.userID })
    await apiListGroupUser.get(`${groupID}/group`)
  }

  // const handleDeleteAll = async () => {
  //   await apiListGroupUser.delete(`group/${groupID}`)
  //   await apiListGroupUser.get(`${groupID}/group`)
  // }

  const HeaderMenu = () =>
    <Menu>
      <MenuAdd text="add" onClick={handleAddShow} show={canAdd} />
      {/* <MenuRemove text="remove all" onClick={handleDeleteAll} show={roleOrgGroupUser.accessDelete} /> */}
    </Menu>

  return (
    <React.Fragment>
      <PermissionGroupUserModal
        target={target}
        groupID={groupID}
        allowAdd={canAdd}
        allowDelete={canDelete}
        onClose={handleClose}
        onClosed={handleClosed}
      />
      <BreadcrumbView Icon={IconUsers} text="Users">
        <CardFullHeightScrollY title="group users" HeaderMenu={HeaderMenu}>
          {!editable &&
            <div className="mb-2" data-testid="managed-group-members-notice">
              <Notice tone="info"><ManagedGroupChip connectionName={managedBy} /> {managedGroupTip(managedBy)}</Notice>
            </div>}
          <TableAgClient apiList={apiListGroupUser} onReady={handleReady} onDestoryed={handleDestroyed}>
            <ColumnText field="email" />
            <ColumnText field="firstName" />
            <ColumnText field="lastName" />
            <ColumnFormat field="managedBySystemKey" header="Partner" render={managedCell} exportValue={row => (isManagedByPartner(row) ? 'Managed by partner' : '')} fit="content" />
            <ColumnFormat field="managedByIdentityProvider" header="Provisioning" render={idpCell} exportValue={row => (!editable && row.managedByIdentityProvider ? MANAGED_GROUP_LABEL : '')} fit="content" />
            <ColumnMenu
              menu={row =>
                <Menu small>
                  <MenuItem Icon={IconCheck} text="keep" title={KEEP_MEMBERSHIP_TIP} pin onClick={() => handleKeep(row)} show={canAdd && isManagedByPartner(row)} />
                  <MenuRemove text="remove" onClick={() => handleDelete(row)} show={canDeleteRow(row)} />
                </Menu>}
            />
          </TableAgClient>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
